<template>
  <div>
    <v-container>
      <div
        class="display-2 mb-7 mt-5 font-weight-thin"
        color="primary"
      >{{$tc('analyzeInput.title',1)}}</div>
    </v-container>
    <v-list>
      <v-list-item-subtitle class="ma-5">{{$tc('analyzeInput.group',1)}} {{group}}</v-list-item-subtitle>
      <div v-for="(input,i) in inputs" :key="i">
        <v-list-item @click="clickInput(input)">
          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{input.namespace.name}}</v-list-item-title>
        </v-list-item>
        <v-divider />
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      group: "",
      inputs: []
    };
  },
  methods: {
    clickInput(analyzeInput) {
      this.$router.push({ name: "Analyze", query: {  analyzeInput : JSON.stringify(analyzeInput)} });
    },
    async getInputs() {
      let res = await this.$http.get(`analyzeinput/inputs?group=${this.group}`);
      if (res.success) this.inputs = res.data;
    }
  },
  async mounted() {
    this.group = this.$route.query.group;
    await this.getInputs();
  }
};
</script>